import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { useGetMarketplaceShowProfile } from './show';
import { useGetMarketplaceHostProfile } from './host';
import CONSTANTS from '../../../../../../../shared/constants';

const shouldRefetchProfile = (profile, phylloData) => {
  if (!phylloData || !profile?.socialMediaLinks) {
    return false;
  }
  const account = Object.values(profile?.socialMediaLinks).find(
    (account) =>
      account?.phyllo?.accountId === phylloData?.accountId &&
      account?.phyllo?.workPlatformId === phylloData?.workplatformId
  );
  return !!phylloData && account?.status !== phylloData?.status;
};

const useGetMarketplaceProfile = () => {
  const { showId, profileId, profileType } = useParams();
  const [phylloData, setPhylloData] = useState(); // {accountId, workplatformId, userId, status}

  const { showProfile, isShowProfileLoading } = useGetMarketplaceShowProfile({
    showId,
    profileId,
    disabled: profileType !== CONSTANTS.MARKETPLACE_PROFILE_TYPES.PODCAST,
    shouldRefetch: (profile) => {
      return shouldRefetchProfile(profile, phylloData);
    },
  });

  const { hostProfile, isHostProfileLoading } = useGetMarketplaceHostProfile({
    showId,
    profileId,
    disabled: profileType !== CONSTANTS.MARKETPLACE_PROFILE_TYPES.HOST,
    shouldRefetch: (profile) => {
      return shouldRefetchProfile(profile, phylloData);
    },
  });

  return {
    profile:
      profileType === CONSTANTS.MARKETPLACE_PROFILE_TYPES.PODCAST ? showProfile : hostProfile,
    isProfileLoading: isShowProfileLoading || isHostProfileLoading,
    refetchProfile: setPhylloData,
  };
};

export default useGetMarketplaceProfile;
